import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import List from './List';
import { useBenefitsListStyles } from './styles';

const BenefitsList = ({ ...props }) => {
  const { image, mobile, open, setOpen, benefits, type } = props;
  const classes = useBenefitsListStyles();

  return (
    <Box className={classes.container}>
      <div className={classes.image}>
        <img src={image} />
      </div>
      <Typography className={classes.subtitle}>
        {`¿Cómo pertenecer a la categoría ${type}?`}{' '}
      </Typography>
      {mobile && (
        <Box display="flex" justifyContent="center">
          {!open && (
            <IconButton
              data-cy="iconButtonOpenBenefitsList"
              onClick={() => setOpen(true)}
            >
              <KeyboardArrowDownIcon fontSize="large" />
            </IconButton>
          )}
        </Box>
      )}
      {open && (
        <React.Fragment>
          <Typography>
            {type === 'Silver'
              ? 'Si acumulas entre 10.000 y 19.999 Ripley Puntos Go por compras realizadas entre el 1 de enero y 31 de diciembre de cada año.'
              : 'Si acumulas más de 20.000 Ripley Puntos Go por compras realizadas entre el 1 de enero y 31 de diciembre de cada año.'}
          </Typography>
          <Typography className={classes.title}>Beneficios</Typography>
          <List benefits={benefits} type={type} />
        </React.Fragment>
      )}
      {mobile && (
        <Box display="flex" justifyContent="center">
          {open && (
            <IconButton
              data-cy="iconButtonCloseBenefitsList"
              onClick={() => setOpen(false)}
            >
              <KeyboardArrowUpIcon fontSize="large" />
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  );
};

BenefitsList.propTypes = {
  image: PropTypes.string,
  data: PropTypes.array,
  mobile: PropTypes.bool,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  benefits: PropTypes.object,
  type: PropTypes.string,
};

export default BenefitsList;
